import type { NavItemType } from 'types';
import DescriptionTwoToneIcon from '@mui/icons-material/Description';
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';
import DomainTwoToneIcon from '@mui/icons-material/DomainTwoTone';
import FlagTwoToneIcon from '@mui/icons-material/FlagTwoTone';
import { IconLayoutDashboard, IconAffiliate, IconTarget } from '@tabler/icons-react';
import { cognitivesPath, dashboardPath, goalsPath } from 'utils/viewpoint';
import { IconHome, IconDatabase, IconChartBar, IconFileReport } from '@tabler/icons-react';

/**
 * The active project's menu. `runId` is the chosen ViewPoint, or null for the latest; Dashboard and
 * Cognitives and Goals follow it, and the caption says which ViewPoint they open so the run in force is never
 * implicit.
 */
export function buildProjectSection(
  project: { id: string; name: string },
  viewpoint: { runId: string | null; number: number | null } = { runId: null, number: null }
): NavItemType {
  const base = `/projects/${project.id}`;
  const sectionId = `project-section-${project.id}`;
  const { runId, number } = viewpoint;
  const cognitives = cognitivesPath(project.id, runId);
  const goals = goalsPath(project.id, runId);

  return {
    id: `project-section-${project.id}`, // ✅ unique per selection
    useI18n: false,
    title: project.name,
    caption: number ? `ViewPoint ${number}${runId ? '' : ' · latest'}` : undefined,
    type: 'group',
    children: [
      {
        id: `${sectionId}-dashboard-${project.id}`,
        title: 'dashboard',
        type: 'item',
        icon: IconLayoutDashboard,
        url: dashboardPath(project.id, runId)
      },
      // `link` keeps the item lit on an individual cognitive, which sits beneath this URL.
      {
        id: `${sectionId}-cognitives-${project.id}`,
        title: 'cognitives',
        type: 'item',
        icon: IconAffiliate,
        url: cognitives,
        link: `${cognitives}/*`
      },
      { id: `${sectionId}-documents-${project.id}`, title: 'documents', type: 'item', icon: IconDatabase, url: `${base}/documents` },
      { id: `${sectionId}-artefacts-${project.id}`, title: 'artefacts', type: 'item', icon: IconChartBar, url: `${base}/artefacts` },
      { id: `${sectionId}-domains-${project.id}`, title: 'domains', type: 'item', icon: IconFileReport, url: `${base}/domains` },
      { id: `${sectionId}-goals-${project.id}`, title: 'goals', type: 'item', icon: IconTarget, url: goals, link: `${goals}/*` }
    ]
  };
}
